<div id="company-detail-view" class="company-detail-view" *ngIf="ShowTabPanels">
    <div class="card-view">
        <div class="top-details">
            <h3>{{companyName}}</h3>
            <div class="button-group">
                <button *ngIf="editBtnShow" mat-raised-button (click)="onEdit()" class="edit">Editar</button>
                <button *ngIf="cancelBtnShow" mat-raised-button (click)="onCancel()" class="warn">Cancelar</button>
                <button *ngIf="guardarBtnShow" mat-raised-button (click)="onSave()" color="warn"
                    class="save">Guardar</button>
            </div>
        </div>
        <div class="company-tab">

                <mat-tab-group #tabGroup (selectedTabChange)="onSelectTabs($event)">
                    <mat-tab label="Empresa" *ngIf="permissionList.includes('20')">
                        <app-empresa *ngIf=" 0 == selectedTab && permissionList.includes('20')" (nodeUpdateEmpresa)="sendData($event) "
                            [companyId]="selectedCompanyId"></app-empresa>
                    </mat-tab>
                    <mat-tab label="Atributos" *ngIf="permissionList.includes('24')">
                        <app-atributos *ngIf=" 1 == selectedTab && permissionList.includes('24')" [companyId]="selectedCompanyId"></app-atributos>
                    </mat-tab>
                    <mat-tab label="Personal de contacto" *ngIf="permissionList.includes('43')" >
                        <app-personal-de-contacto *ngIf="2 == selectedTab && permissionList.includes('43')" [companyId]="selectedCompanyId">
                        </app-personal-de-contacto>
                    </mat-tab>
                    <mat-tab label="Registro" *ngIf="permissionList.includes('9')">
                        <app-register-tab *ngIf=" 3 == selectedTab && permissionList.includes('9')" [companyId]="selectedCompanyId"></app-register-tab>
                    </mat-tab>
                    <mat-tab label="Convenios" *ngIf="permissionList.includes('45')">
                        <app-convenios *ngIf=" 4 == selectedTab && permissionList.includes('45')" [companyId]="selectedCompanyId"></app-convenios>
                    </mat-tab>
                    <mat-tab label="Absentismo" *ngIf="permissionList.includes('6')">
                        <app-dashboard *ngIf=" 5 == selectedTab && permissionList.includes('6')" [companyId]="selectedCompanyId"></app-dashboard>
                    </mat-tab>
                    <mat-tab label="Documentación" *ngIf="permissionList.includes('50')">
                        <app-documents *ngIf=" 6 == selectedTab && permissionList.includes('50')" [companyId]="selectedCompanyId"></app-documents>
                    </mat-tab>
                    <mat-tab *ngIf="permissionList.includes('15')" label="Protocolo">
                        <div>
                            <div class="form-wrap full-field">
                                <mat-label class="label">Observaciones </mat-label>
                                <mat-form-field class="full-width" appearance="fill">
                                    <textarea matInput  [disabled]="!isProtolo" [readonly]="!isProtolo" [(ngModel)]="protocolo" placeholder="" rows="35"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>

        </div>
    </div>
</div>